export default {
  customer: {
    prev: "上一頁",
    nextv: "下一頁",
    noAuth: "您無權查看此視頻",
    catchword: "信仰創新的力量",
    placeholderSearch: "關鍵字",
    pleaseLogin: "您好！請登錄",
    level1: "項目類別：",
    home: "首頁",
    reset: "重置",
    unit1: "人",
    unit2: "條",
    coursevalue: "課程價值",
    noData: "暫無數據",
    pleaseReview: "給该課程評分：",
    publish: "發表",
    reviewArea: "评论区",
    pubSuc: "發表成功",
    me: "我",

  },
  global: {
    allTestComp: '全部任務已完成啦',
    testEnd: '任務已結束',
    test: '任務未開始',
    view: '人觀看',
    identity1: "User ",
    identity2: "Customer ",
    pleaseChoose: "選擇登錄身份",
    docTitle1: "itc商學院",
    docTitle2: "知之會議錄播平臺",
    forget: "忘記密碼？",
    warningTitle: "版權聲明",
    warning:
      "本課程版權歸廣東保倫電子股份有限公司所有，僅限個人學習，嚴禁任何形式的錄製、傳播和賬號分享。一經發現，公司將依法保留追究權，情節嚴重者將承擔法律責任。",
    sectionNum: "第{num}節",
    sort1: "一級分類",
    sort2: "二級分類",
    pleaseSignIn: "請登錄",
    image: "圖片",
    search: "搜索",
    choose: "請選擇",
    searchKeyword: '請輸入關鍵詞查詢',
    keyword: "關鍵字",
    sure: "確定",
    save: "保存",
    submit: "提交",
    cancel: "取消",

    noData: "暫無數據",
    noDataTable: "暫無更新，敬請期",
    play: "播放",
    noCate: "暫無分類",
    noPoster: "暫無封面",
    top: "置頂",
    download: "下載",
    downCount: "下載量",
    allowDown: "允許下載",
    allowShare: "允許分享",
    resourceCate: "資料分類",
    back: "返回",
    yes: "是",
    no: "否",
    all: "全部",
    allCate: "全部分類",
    defaultSort: "默認分類",
    uploadTime: "上傳時間",
    keepTime: "保存時間",
    size: "大小",
    score: "評分",
    check: "查看",
    copy: "複制",
    copySuccess: "複製成功",
    type: "類型",
    collect0: "已取消收藏",
    collect1: "收藏成功",
    tips: "提示",
    nokeyword: "暫無關鍵字",
    forever: "永久保存",
    halfYear: "半年",
    oneYear: "一年",
    month: "個月",
    loading: "加載中",
    selectDate: "選擇日期",
    authorityMessage: "暫無觀看權限，請聯繫管理員開通",
    authorityMessage1: "當前視頻限制觀看權限，請登錄后查看",
    copyUrlmessage: "複製鏈接發送用戶，即可通過網頁或H5查看分享內容",
    webUrl: "網頁端",
    H5Url: "移動端",
    linkUrl: "鏈接",
    successfullyScored: "評分成功",
    complete: "完成",
  },
  form: {
    web: '官網',
    companyName: '公司名稱',
    changePass: "重設密碼",
    certify: "身份確認",
    certifySuc: "認證成功",
    getCodeSuc: "驗證碼已發送",
    reGetCode: "重新獲取",
    getCode: "獲取驗證碼",
    phoneNumErr: "手機號碼錯誤",
    position: "職位",
    email: "郵箱",
    email1: "請輸入郵箱地址",
    emailEmpty: "郵箱不能為空",
    rightEmail: "請輸入正確的郵箱",
    phone: "手機",
    phone1: "請輸入手機號",
    phone2: "請輸入手機號碼",
    rightPhone: "請輸入正確的手機號",
    pleaseInput: "請輸入您的問題內容",
    typeEmpty: "請選擇問題類型",
    codeEmpty: "請輸入驗證碼",
    codeError: "請輸入正確的驗證碼",
    maxl20: "最多可以輸入20個字元",
    submiting: "正在保存中，請勿刷新流覽器",
    resEmpty: "請填寫資料名稱",
    chooseFile: "請上傳檔",
    addr: "地址",
    number: "聯係電話",
  },
  response: {
    timeOut: "請求超時",
  },
  modules: {
    live: "線上直播",
    video: "視頻點播",
    settings: "賬號設置",
  },
  rules: {
    enterAcc: "請輸入用戶帳號",
    account: "帳號由4~16位英文、數字、下劃線組成",
    pwd: "密碼由6~16位英文、數字、下劃線組成",
    strongPwd:
      "密码限制8~16，由数字、大写字母、小写字母，特殊符号3种或3种以上组合组成",
    spaceKey: "請勿輸入空格",
    trim: "內容前後不可有空格",
    leftTrim: "內容前面不可有空格",
    rightTrim: "內容後面不可有空格",
    mobile: "電話格式不正確",
    ip: "請輸入正確的ip地址",
    port: "請輸入正確的端口",
    mask: "請輸入正確的子網掩碼",
    chinese: "請勿輸入特殊字元",
    link: "鏈接格式錯誤",
  },
  upload: {
    pic: "上傳圖片",
    success: "上傳成功",
    fail: "上傳失敗",
    error: "上傳出錯",
    uploading: "正在上传，请稍等...",
    paused: "暫停",
    waiting: "等待上傳",
    imgType: "只允許上傳圖片格式的檔",
    score2M: "只允許上傳2M以內的檔",
  },
  homepage: {
    studyTest: '學習任務',
    special_tcamp: "專項訓練營",
    product_focus: "新上好課",
    nice_video: "精品推薦",
    Visitors: "遊客無權進入",
    noOpen: "此功能暫未開放",
    needLogin: "此功能需登錄後才能使用",
    pleaseLogin: "你好,请登录",
    loginFirst: "請先登錄",
    register: "註冊",
    changeRole: "切換身份",
    manage: "管理中心",
    settings: "賬號設置",
    loginOut: "安全退出",
    newRes: "最新資料",
    more: "更多",
    moreVideo: "更多視頻",
    hotVideo: "熱門視頻",
    aboutUs: "關於我們",
    news: "新聞公告",
    newsDetail: "資訊詳情",
    annex: "附件",
    latest: "最新資訊",
    like0: "未點贊",
    like1: "已點贊",
    operation: "操作手冊",
    question: "常見問題",
    user: "用戶回饋",
    write: "填寫回饋",
    feedback: "問題回饋",
    tips1: "請在下方填寫您在使用過程中遇到的問題，我們將仔細閱讀您的回饋！",
    tips2:
      "請盡可能詳細地描述您遇到的問題，您的回饋將是我們提升平臺品質的最好保證",
    identify: "看不清，再換一張",
    questionType: "問題類型",
    selectQues: "請選擇問題類型",
    yourEmail: "你的郵箱",
    msgEasy: "方便我們更快地聯繫到你",
    code: "驗證碼",
    string4: "輸入右側四位字元",
    resource: "資料",
    album: "專輯",
    time: "時間",
    resource_cate: "分類",
    uploadResource: "上傳我的資料",
    ranking: "下載排行",
    uploadRes: "上傳資料",
    downloadRes: "資料下載",
    chooseRes: "選擇資料",
    resTypes: "支持常用文檔，圖片，音頻，壓縮檔等格式",
    resName: "資料名稱",
    Moderated: "請等待管理員審核",
    shareLink: "分享鏈接",
    transcoding: "正在轉碼中，稍等片刻刷新頁面觀看",
    deleted: "當前資料已被刪除",
    onlyDown: "此資料僅供下載，不支持預覽",
    canotDown: "該資料創建者不允許下載",
    course: "課程",
    learner: "學習人數",
    catalog: "專輯目錄",
    introduction: "專輯介紹",
    video: "視頻",
    videoDeleted: "視頻已被刪除",
    test: "考題",
    chapter: "第1章",
    playCounts: "總播放量",
    popularity: "人氣",
    heat: "熱度",
    testDetail: "試卷詳情",
    fullMarks: "滿分",
    marks: "分",
    difficulty: "難度",
    answer: "答案",
    statistics: "統計",
    result1: "共2題，1分",
    result2: "本題共被作答2次，正確率為1%",
    analysis: "解析",
    closeAnalysis: "關閉解析",
    checkAnalysis: "查看解析",
    downTest: "下載試卷",
    template: "範本",
    A4: "A4紙豎排",
    A3: "A3紙豎排",
    answerType1: "試題後面緊跟答案",
    answerType2: "試題和解析分離",
    answerType3: "只下載試卷",
    answerType4: "只下載答案",
    videoCate: "視頻分類",
    videoIntr: "視頻簡介",
    testStatus: '已完成',
    hasComplete: '待完成',
    videoNotice: "視頻須知",
    classIntr: "課程介紹",
    teacherIntr: "講師介紹",
    comment: "評分評論",
    score: "給該課程評分",
    plaComment: "快來點評一下吧，大膽說出你的想法~",
    yes: "確定",
    comments: "評論",
    teacherInfo: "講師資訊",
    otherClass: "其他課程",
    watched: "觀看過的人",
    enterLive: "進入直播間",
    forbitted: "你已被限制觀看",
    checkArea: "查看限制範圍",
    noAllow: "不能查看的範圍",
    inputPsw: "輸入直播密碼",
    pswSetted: "該直播設置了觀看密碼，需要輸入密碼才能觀看哦",
    getPsw: "请联系主讲人：{speaker} 获取密码",
    living: "直播中",
    notStart: "未開始",
    liveOver: "直播已結束",
    liveNeedLogin: "該直播需要登錄才能觀看",
    liveName: "直播名稱",
    liveTime: "直播時間",
    onlineCounts: "線上人數",
    liveIntr: "直播簡介",
    barrageOpen: "彈幕已開啟",
    barrageOff: "彈幕已關閉",
    connect: "網絡異常，請檢查網絡",
    discuss: "討論區",
    yourWord: "寫下你想說的話",
    member: "成員",
    shareAddr: "分享地址",
    forbit: "你已經被禁言了",
    forbit2: "該詞已禁用，請重新輸入討論內容",

    grading: "給該課程評分",
    profileHolder: "快來點評一下吧，大膽想說出你的想法~",
    cutImage: "截圖",
    edit: "編輯",
    delete: "刪除",
    commontCutImage: "評論截圖",
    addComments: "請輸入評論內容",
    delCommentsWhat: "確定要刪除此評論嗎",
    delSuccess: "刪除成功",
    notDel: "已取消刪除",
  },
  register: {
    relogin: "重新登錄？",
    gologin: "返回登錄",
    login: "登錄",
    account: "帳號",
    hasAccount: "已經有帳號？",
    hasAccount2: "已有帳號？",
    back: "返回登錄",
    username: "用戶名",
    namePl: "請填寫真實姓名",
    nameEmpty: "真實姓名不能為空",
    gender: "性別",
    genderEmpty: "性別不能為空",
    male: "男",
    female: "女",
    department: "部門",
    inputDepartment: "請選擇所屬部門",
    accountEmpty: "帳號不能為空",
    psw: "密碼",
    psw1: "請輸入密碼",
    newPsw: "請輸入新密碼",
    nowPsw: "當前密碼",
    imputOldPsw: "請輸入舊密碼",
    psw6: "請輸入6位數密碼",
    pswtip: "密碼由6~16位英文、數字、下劃線組成",
    psw16: "密碼長度為6~16個字元哦",
    pswEmpty: "密碼不能為空",
    checkPsw: "確認密碼",
    psw200: "密碼修改成功",
    checkPswPl: "重複密碼",
    checkTwice: "請再次輸入密碼",
    noSame: "兩次輸入密碼不一致",
    rememberTip: "重要資訊，用於登錄，請謹記！",
    submit: "提交註冊",
    confirmed: "確認無誤，提交註冊",

    noAccount: "沒有賬號？",
    signUpNow: "立即註冊",
    loginPlease: "歡迎登錄~",

    newPassword: "新密碼",
    surePassword: "確認密碼",
    changeSuccess: "修改成功，請重新登錄",
  },
  settings: {
    title1: "基本信息",
    title2: "修改密碼",
    avatar: "頭像",
    loginAcc: "登錄帳戶",
    relName: "請輸入真實姓名",
    replace: "替換",
    intro: "個人簡介",
    introTip: "將你獨特的一面展示給大家吧",
  },
  cdkey: {
    systemOverdue0: "系統已過期",
    systemOverdue: "您的系統已過期",
    getRegistrationKey: "為了不影響您的使用，請聯繫相關業務員獲取註冊碼",
    serialNumber: "系列號",
    placeholder1: "將獲取的序列號粘貼到此處",
    RegistrationCode: "註冊碼",
    placeholder2: "將獲取的激活碼粘貼到此處",
    activation: "激活",
    partTime: "生效時間",
    partModel: "移動端激活模塊",
    android: "安卓",
    OnActivation: "已激活",
    UnActivation: "未激活",
    message: "請輸入註冊碼",
    activationSuccess: "激活成功",
    activationFail: "激活失敗",
    InfiniteDays: "無限天",
  },
};
